module.exports = __webpack_public_path__ + "static/img/5.e4d8d6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/zh/5.png
// module id = WubK
// module chunks = 0